var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('b-spinner',{attrs:{"variant":"primary"}}):_c('Reps',{attrs:{"reps":_vm.reps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }